import { Api } from "./Api";
import JSON5 from "json5";
import { parseISO, format } from "date-fns";

export const parseOrganizationData = (
  organizationData: IAxiosResponseData,
): IOrganization => {
  /**
   * Parse organization data from the API response, to an IOrganization object.
   */
  const google_places: IGooglePlacesObject[] =
    organizationData.google_places.map(
      (googlePlacesData: IAxiosResponseData[]) =>
        parseGooglePlacesData(googlePlacesData),
    );
  const bedrijfsdata: IBedrijfsdataObject[] = organizationData.bedrijfsdata.map(
    (bedrijfsdataData: IAxiosResponseData[]) =>
      parseBedrijfsdataData(bedrijfsdataData),
  );
  return {
    id: organizationData.organization_id,
    name: organizationData.name_formatted,
    websiteDomain: organizationData.website_domain,
    googlePlaces: google_places,
    bedrijfsdata: bedrijfsdata,
    appData: organizationData.app_data
      ? parseOrganizationAppDataData(organizationData.app_data)
      : null,
  } as IOrganization;
};

export const parseGooglePlacesData = (
  googlePlacesData: IAxiosResponseData,
): IGooglePlacesObject => {
  /**
   * Parse Google Places data from the API response, to an IGooglePlacesObject object.
   */
  return {
    id: googlePlacesData.google_place_id,
    name: googlePlacesData.google_display_name,
    phoneNumber: googlePlacesData.google_phone_number,
  } as IGooglePlacesObject;
};

export const parseBedrijfsdataData = (
  bedrijfsdataData: IAxiosResponseData,
): IBedrijfsdataObject => {
  /**
   * Parse Bedrijfsdata from the API response, to an IBedrijfsdataObject object.
   */
  return {
    id: bedrijfsdataData.bedrijfsdata_id,
    name: bedrijfsdataData.company_name,
    kvkNumber: bedrijfsdataData.kvk_number,
    phoneNumber: bedrijfsdataData.phone_number,
    email: bedrijfsdataData.email_address,
    foundationYear: bedrijfsdataData.foundation_year,
    numberOfEmployees: bedrijfsdataData.n_employees,
    organizationType: bedrijfsdataData.organization_type,
    locationType: bedrijfsdataData.location_type,
    linkedinLink: bedrijfsdataData.linkedin_link,
    facebookLink: bedrijfsdataData.facebook_link,
    youtubeLink: bedrijfsdataData.youtube_link,
    instagramLink: bedrijfsdataData.instagram_link,
    pinterestLink: bedrijfsdataData.pinterest_link,
    sbiCodes: JSON5.parse(bedrijfsdataData.sbi_codes),
    kvkBranches: JSON5.parse(bedrijfsdataData.branches_kvk),
  } as IBedrijfsdataObject;
};

export const parseOrganizationAppDataData = (
  bagObjectAppDataData: IAxiosResponseData,
): IOrganizationAppData => {
  /**
   * Parse organization app data from the API response, to an IOrganizationAppData object.
   */
  return {
    notes: bagObjectAppDataData.notes,
    lastContacted: bagObjectAppDataData.last_contacted
      ? parseISO(bagObjectAppDataData.last_contacted)
      : null,
  } as IOrganizationAppData;
};

export const updateOrganizationAppData = async (
  organizationId: string,
  organizationAppData: IOrganizationAppData,
): Promise<void> => {
  /**
   * Update an organization's app data.
   */
  const path = `/organizations/${organizationId}/app-data/`;
  const formData = {
    notes: organizationAppData.notes,
    last_contacted: organizationAppData.lastContacted
      ? format(organizationAppData.lastContacted, "yyyy-MM-dd")
      : null,
  };
  await Api.post(path, formData);
};
